import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'

Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class SecurityRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    qs('.disclaimer')?.classList?.remove?.('hide')
    store.resizeFn = null
    store.section = 'home'
    store.sectionProdId =
      this.properties.page.URL.split('/')[this.properties.page.URL.split('/').length - 1]

    this.setHeaderStyle('white')
    this.onPageChange()
    this.slideHome()
    //qs(`.disclaimer .${store.sectionProdId}`).style.display = 'block';
    var objThis = this
    qsa('.faq-row').forEach((element) => {
      element.addEventListener('click', function () {
        if (!this.classList.contains('active')) {
          $('.faq-row').removeClass('active')
          $('.faq-row').attr('aria-expanded', 'false')
          $('.faq-row p').slideUp()
          this.classList.add('active')
          $(this).attr('aria-expanded', 'true')
          // $(this+' p').slideToggle();
          $(this)
            .find('p')
            .slideToggle(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        } else {
          $(this).attr('aria-expanded', 'false')
          this.classList.remove('active')
          $(this)
            .find('p')
            .slideUp(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        }
      })
    })
  }

  onEnter() {
    super.onEnter()
    qs('.disclaimer')?.classList?.remove?.('hide')
    qs('.disclaimer')?.classList?.add?.(this.properties.slug)

    qs('.main-home').classList.add('shorten')
    setTimeout(
      () => {
        qs('#more-o-learn').classList.add('active')
      },
      store.flags.first ? 2000 : 0,
    )
    if (qs('.phone-desktop-slide')) {
      this.phoneSlide && this.phoneSlide.destroy()
      setTimeout(() => {
        this.setPhone()
      }, 1000)
    }
  }

  onLeave() {
    super.onLeave()
    qs('.disclaimer')?.classList?.add?.('hide')
    qs('.disclaimer')?.classList?.remove?.(this.properties.slug)
    qs('#more-o-learn')?.classList?.remove?.('active')
    qs('.main-home')?.classList?.remove?.('shorten')
    //qs(`.disclaimer .${store.sectionProdId}`).style.display = 'none';
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    qs('.disclaimer') && qs('.disclaimer')?.classList?.add?.('hide')
    super.onLeaveCompleted()
  }

  slideHome() {
    // if (store.bounds.ww > 900)
    setTimeout(() => {
      const $slideHomeContent = qsa('.h-s-i-back')
      var maxHeight = 0
      $slideHomeContent.forEach(($elem) => {
        if ($elem.offsetHeight > maxHeight) maxHeight = $elem.offsetHeight
      })
      $slideHomeContent.forEach(($elem) => {
        $elem.style.height = maxHeight + 'px'
      })
    }, 1000)
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 4000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    const homeSlide = new Swiper('.home-slide', {
      slidesPerView: 'auto',
      spaceBetween: 88,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      ...autoplayObj,
      loop: true,
      speed: 1000,
      pagination: {
        el: '.home-slide-dots',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button class="' +
            className +
            '" role="button">' +
            '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
            '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
            'stroke-opacity="1" stroke-width="1.5px"></circle>' +
            '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
            '</svg></button>'
          )
        },
      },
      breakpoints: {
        900: {
          autoHeight: false,
        },
      },
    })

    const homeSlideNumbers = new Swiper('#numbers-slide', {
      slidesPerView: 1,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
      pagination: {
        el: '.home-slide-numbers-dots',
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<button class="' +
            className +
            '" role="button">' +
            '<svg class="fp-arc-loader" width="16" height="16" viewBox="0 0 16 16">' +
            '<circle class="path" cx="8" cy="8" r="5.5" fill="none" transform="rotate(-90 8 8)" stroke="#FFF"' +
            'stroke-opacity="1" stroke-width="1.5px"></circle>' +
            '<circle cx="8" cy="8" r="3" fill="transparent"></circle>' +
            '</svg></button>'
          )
        },
      },
    })

    const homeSlideLinks = new Swiper('#hero-links-slide', {
      slidesPerView: 2,
      // spaceBetween: 100,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: true,
      speed: 1000,
      ...autoplayObj,
    })
    autoplayObj = {
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }

    const heroSlide = new Swiper('.hero-slide-text', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      loop: true,
      speed: 1000,
      navigation: {
        nextEl: '.h-s-next',
        prevEl: '.h-s-prev',
      },
      breakpoints: {
        900: {
          ...autoplayObj,
        },
      },
    })
  }

  setPhone() {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

    let autoplayObj = {
      autoplay: {
        delay: 5000,
        waitForTransition: true,
        disableOnInteraction: false,
      },
    }
    if (!mediaQuery || mediaQuery.matches) {
      autoplayObj.autoplay = false
    }
    this.phoneSlide = new Swiper(qs('.phone-desktop-slide'), {
      slidesPerView: 1,
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      spaceBetween: 10,
      speed: 1000,
      ...autoplayObj,
    })

    const options = qsa('.h-woption')
    options.forEach((o) => {
      o.addEventListener('click', () => {
        this.phoneSlide.slideTo(parseInt(o.dataset.opt.replace('opt-', '')))
        this.phoneSlide.update()
      })
    })

    this.phoneSlide.on('activeIndexChange', function () {
      options.forEach(($h) => {
        $h.classList.remove('active')
      })
      qs('.h-woption[data-opt=opt-' + this.activeIndex + ']') &&
        qs('.h-woption[data-opt=opt-' + this.activeIndex + ']').classList.add('active')
    })
  }
}

export default SecurityRenderer
